import React from 'react';
import { SVGS } from '../../assets';
import { getClockInInfo, useAppSelector } from '@zonofi/zono-money-store';
import './clock-in-modal.scss';

export const NoInternetView: React.FC = ({}) => {
  const clockInInfo = useAppSelector(getClockInInfo);

  return (
    <div className="clockIn-no-internet">
      <img src={SVGS.NoInternet} className="clockIn-no-internet__image" />
      <div className="clockIn-no-internet__content">
        <span className="clockIn-no-internet__content-title font-semibold">
          {'No Internet'}
        </span>
        <span className="clockIn-no-internet__content-sub-title font-regular">
          {`In order to ${clockInInfo?.tripId ? 'Clock out' : 'Clock in'} you need to be connected`}
          <br />
          {`to an active internet connection.`}
        </span>
      </div>
    </div>
  );
};
